/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-underscore-dangle */
import React, { useContext, useState } from 'react';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { Col, Row, message, Divider, Checkbox } from 'antd';
import { useMutation } from '@apollo/react-hooks';
import {
  BillingNoteContext,
  SelectedBillingNoteDetailType,
} from 'views/AccountReceive/common/context/BillingNoteContext';
import UPDATE_BILLING_NOTE_MUTATION, {
  UpdateBillingNoteVars,
  UpdateBillingNoteData,
} from 'shared/graphql/mutation/updateBillingNote';
import formatCurrency from 'shared/utils/formatCurrency';
import { Button, Text } from 'shared/components';
import { formatDate } from 'shared/utils/dateTime';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { StyledModal } from './Styles';

type ModalConfirmCreateInvoiceProps = {
  visible: boolean;
  onCancel: () => void;
};

const ModalConfirmUpdate: React.FC<ModalConfirmCreateInvoiceProps> = (props) => {
  const { onCancel, visible } = props;
  const { selectedBillingNoteDetail, setSelectedBillingNoteDetail } = useContext(
    BillingNoteContext,
  );
  const { modalConfirmUpdate, billingNoteId } = selectedBillingNoteDetail;
  const { invoices, businessInvoiceType, payerFullName, grandTotalPrice } = modalConfirmUpdate;
  const [checkSendEmail, setCheckSendEmail] = useState<boolean>();

  const [updateBillingNote, { loading }] = useMutation<
    UpdateBillingNoteData,
    UpdateBillingNoteVars
  >(UPDATE_BILLING_NOTE_MUTATION, {
    update: (_cache, { data }) => {
      if (data?.updateBillingNote._id) {
        message.success('วางบิลลูกค้าแล้ว');
        onCancel();
        setSelectedBillingNoteDetail(
          (prevState): SelectedBillingNoteDetailType => ({
            ...prevState,
            isOpenModal: false,
          }),
        );
      }
    },
    onError: (err) => {
      message.error(err.message);
    },
    refetchQueries: () => ['BillingNote', 'BillingNoteStatus', 'BillingNotes'],
  });

  const confirmUpdate = () => {
    updateBillingNote({
      variables: {
        _id: billingNoteId,
        bill_status: 2,
        send_email: checkSendEmail,
      },
    });
  };

  const sendEmail = (e: CheckboxChangeEvent) => {
    setCheckSendEmail(e.target.checked);
  };

  return (
    <StyledModal
      className="custom-modal"
      title="ยืนยันการวางบิลลูกค้าใช่หรือไม่?"
      visible={visible}
      onCancel={onCancel}
      footer={[
        <Button
          key="okButton"
          icon={<CheckCircleOutlined />}
          color="green"
          onClick={() => confirmUpdate()}
          loading={loading}
        >
          ใช่, วางบิลลูกค้า
        </Button>,
        <Button
          key="cancelButton"
          icon={<CloseCircleOutlined />}
          onClick={onCancel}
          disabled={loading}
        >
          ยกเลิก
        </Button>,
      ]}
    >
      <Row>
        <Col span={6}>
          ลูกค้า <Text customType="grey">(ลูกหนี้)</Text>:
        </Col>
        <Col span={18}>
          <Text strong>{payerFullName}</Text>
        </Col>
      </Row>
      <Row>
        <Col span={6}>รูปแบบรับใบแจ้งหนี้:</Col>
        <Col span={18}>
          <Text strong>{businessInvoiceType}</Text>
        </Col>
      </Row>
      <Row>
        <Col span={6}>มูลค่าใบวางบิล:</Col>
        <Col span={18}>
          <Text strong customType="primary">
            {formatCurrency(grandTotalPrice, '0')}
          </Text>
        </Col>
      </Row>

      <Divider style={{ marginTop: 10, marginBottom: 10 }} />

      <Row>
        <Col span={24}>
          ทั้งหมด <Text strong>{`${invoices.length} รายการ`}</Text>
        </Col>
        <Col span={24}>
          <Row gutter={[8, 0]}>
            <Col span={4}>วันที่เอกสาร</Col>
            <Col span={4}>รหัสใบแจ้งหนี้</Col>
            <Col span={4}>มูลค่าใบแจ้งหนี้</Col>
          </Row>

          {invoices.map((item) => (
            <Row gutter={[8, 0]}>
              <Col span={4}>
                <Text strong>{item.createDate ? formatDate(item.createDate) : '-'}</Text>
              </Col>
              <Col span={4}>
                <Text strong>{item.invoiceNumber || '-'}</Text>
              </Col>
              <Col span={4}>
                <Text strong customType="primary">
                  {formatCurrency(item.grandTotalPrice)}
                </Text>
              </Col>
            </Row>
          ))}
          <Row gutter={[16, 0]} style={{ marginTop: 30 }}>
            <Col span={16}>
              <Checkbox onChange={(e) => sendEmail(e)}>ส่งใบวางบิลผ่านอีเมลให้ลูกค้าทันที</Checkbox>
            </Col>
          </Row>
        </Col>
      </Row>
    </StyledModal>
  );
};

export default ModalConfirmUpdate;
